// apps/client/src/modules/public/product-page/index.ts

import { WFComponent, WFDynamicList, WFFormComponent, navigate } from "@xatom/core";
import { publicQL } from "../../../graphql";
import {
  SendQuoteDocument,
  SendQuoteGuestUserDocument,
  ListProjectProductsDocument,
  AddNewProjectDocument,
  ListProjectsDocument,
  AddToProjectDocument,
  SendSingleProductQuoteDocument,
  CreateRoomDocument,
  ListRoomsDocument,
  ListRoomsGuestDocument,
} from "../../../graphql/graphql";
import { GUEST_ROOMS_LOCALSTORAGE_KEY, GUEST_PROJECTS_LOCALSTORAGE_KEY, PLACEHOLDER_IMAGE, PUBLIC_PATHS, S3_BASE_URL } from "../../../config";
import { publicAuth } from "../../../auth/public";
const lastAddedProduct = null;
export const productPage = () => {
  const addToProjectReq = publicQL.mutation(AddToProjectDocument);
  const addToProjectButton = new WFComponent(`[xa-type="add-to-project-btn"]`);
  if (!publicAuth.isLoggedIn()) {
    addToProjectButton.addCssClass("hide");
  }
  const name = new WFComponent(`[xa-type="product-name"]`).getText();
  const brand = new WFComponent(`[xa-type="product-brand"]`).getText();
  // Product image thumbnail
  const productImage = new WFComponent(`[xa-type="product-img-thumbnail"]`);
  let thumbnail = "";
  try {
    thumbnail = productImage.getAttribute("src") || "";
  } catch (err) {
    console.error("Error getting product thumbnail:", err);
  }
  const productSlug = addToProjectButton.getAttribute("xa-slug");
  const leadTime = addToProjectButton.getAttribute("xa-lead-time");
  const price = parseInt(addToProjectButton.getAttribute("xa-price"));
  const salePrice = parseInt(addToProjectButton.getAttribute("xa-sale-price") || "0");
  const createNewProjectReq = publicQL.mutation(AddNewProjectDocument);
  const listProjectReq = publicQL.mutation(ListProjectsDocument);
  const createProjectButton = new WFComponent(`[xa-type="create-new-project-btn"]`);
  const addProjectForm = new WFFormComponent<{
    "project-name": string;
  }>(`[xa-type="add-project-form"]`);
  const createProjectButtonModal = new WFComponent(`[xa-type="create-btn"]`);
  const cancelProjectButtonModal = new WFComponent(`[xa-type="cancel-btn"]`);
  const formSubmitButton = new WFComponent(`[xa-type="form-submit-btn"]`);
  const successMessageBox = new WFComponent(`[xa-type="success-message-text"]`);
  const errorMessageBox = new WFComponent(`[xa-type="error-message-text"]`);
  const notificationTitle = new WFComponent(`[xa-type="project-name-notification"]`);
  const notificationLink = new WFComponent(`[xa-type="view-project-notification-link"]`);
  const notificationTrigger = new WFComponent(`[xa-type="project-notification-trigger"]`);
  const engagementPopupTrigger = new WFComponent(`[xa-type="engagement-popup-trigger"]`);
  const emptyState = new WFComponent(`[xa-type="project-empty-state"]`);
  const roomsListpopupTrigger = new WFComponent(`[xa-type="room-popup-open"]`);
  const listRoomsReq = publicQL.query(ListRoomsDocument, { fetchPolicy: "network-only" });
  const listRoomsGuestReq = publicQL.query(ListRoomsGuestDocument);
  const createRoomReq = publicQL.mutation(CreateRoomDocument);
  const ROOM_THUMBNAIL = "https://cdn.prod.website-files.com/64ec87f3cc340318d54e715d/6793fb92ae655a1d3291ef04_tollgard-room.webp";
  let globalGuestRoomData = [];
  // Room create
  const addRoomForm = new WFFormComponent<{
    "room-name": string;
  }>(`[xa-type="add-room-form"]`);
  const createRoomBtn = new WFComponent(`[xa-type="create-room-btn"]`);
  const closeRoomBtn = new WFComponent(`[xa-type="room-creator-close"]`);
  const formSubmitBtn = new WFComponent(`[xa-type="room-submit-btn"]`);

  addRoomForm.onFormSubmit((data) => {
    const roomName = data["room-name"].trim();
    if (!roomName || roomName.length < 3) return;

    if (isGuestUser) {
      let roomsData = JSON.parse(localStorage.getItem(GUEST_ROOMS_LOCALSTORAGE_KEY) || "[]");

      const newRoom = {
        id: generateRandomId(),
        name: roomName,
        thumbnail: ROOM_THUMBNAIL,
      };
      roomsData.push(newRoom);
      // Add room to all projects if rooms array doesn't exist
      // projectData.forEach((project) => {
      //   if (!project.rooms) {
      //     project.rooms = [];
      //   }
      //   // project.rooms.push({ ...newRoom }); // Using spread to avoid reference issues
      // });
      roomsData = roomsData.map((r) => ({
        id: r.id,
        name: r.name,
        thumbnail: r.thumbnail || ROOM_THUMBNAIL,
      }));
      localStorage.setItem(GUEST_ROOMS_LOCALSTORAGE_KEY, JSON.stringify(roomsData));

      // Update room list display
      // const firstProject = projectData[0];
      // if (firstProject && firstProject.rooms) {
      //   roomsList.setData(
      //     firstProject.rooms.map((r) => ({
      //       id: r.id,
      //       name: r.name,
      //       thumbnail: r.thumbnail || ROOM_THUMBNAIL,
      //     }))
      //   );
      // }
      roomsData = [...globalGuestRoomData, ...roomsData];
      roomsList.setData(roomsData);
      roomsList.forceRender();
      closeRoomBtn.getElement().click();
    } else {
      createRoomReq.fetch({
        name: roomName,
      });
    }
  });

  createRoomReq.onData((data) => {
    if (data.createRoom) {
      if (isGuestUser) {
      } else {
        listRoomsReq.fetch();
      }
      closeRoomBtn.getElement().click();
    }
  });

  const handleRoomSelection = (projectId: string, selectedRoom: string) => {
    if (isGuestUser) {
      const projectListData = JSON.parse(localStorage.getItem(GUEST_PROJECTS_LOCALSTORAGE_KEY) || "[]");
      const currentProject = projectListData.find((p) => p.id === projectId);

      if (currentProject) {
        currentProject.products.push({
          brand,
          name,
          leadTime: leadTime ? leadTime : "N/A",
          notes: "",
          price,
          salePrice,
          productSlug,
          projectId,
          qty: 1,
          thumbnail,
          category: selectedRoom,
          project: {
            projectName: currentProject.projectName,
          },
        });

        currentProject.noOfProducts = (currentProject.noOfProducts || 0) + 1;
        localStorage.setItem(GUEST_PROJECTS_LOCALSTORAGE_KEY, JSON.stringify(projectListData));

        notificationTitle.setText(currentProject.projectName);
        notificationTrigger.getElement().click();
        cancelProjectButtonModal.getElement().click();
      }
    }
  };

  createRoomBtn.on("click", () => {
    formSubmitBtn.getElement().click();
  });

  const roomsList = new WFDynamicList<
    {
      id: string;
      name: string;
      thumbnail: string;
    },
    HTMLDivElement,
    HTMLDivElement,
    HTMLDivElement
  >(`[xa-type="room-list"]`, {
    rowSelector: `[xa-type="room-item"]`,
  });
  const updateEmptyState = (projectCount: number) => {
    const projectListElement = new WFComponent(`[xa-type="project-list"]`);
    if (projectCount === 0) {
      emptyState.removeCssClass("hide");
      projectListElement.addCssClass("hide");
    } else {
      emptyState.addCssClass("hide");
      projectListElement.removeCssClass("hide");
    }
  };
  const isGuestUser = publicAuth.getUser().email === "guestuser@tollgard.test";
  if (isGuestUser) {
    const signInButtonTrigger = new WFComponent(`[xa-type="signin-btn-trigger"]`);
    const engagementPopupSignIn = new WFComponent(`[xa-type="engagement-popup-signin"]`);
    engagementPopupSignIn.on("click", () => {
      setTimeout(() => {
        signInButtonTrigger.getElement().click();
      }, 1000);
    });
  }

  const initRooms = () => {
    roomsList.rowRenderer(({ rowData, rowElement }) => {
      const name = rowElement.getChildAsComponent(`[xa-type="room-name"]`);
      const image = rowElement.getChildAsComponent(`[xa-type="room-image"]`);
      name.setText(rowData.name);
      image.setAttribute("src", rowData.thumbnail || ROOM_THUMBNAIL);

      rowElement.on("click", () => {
        if (isGuestUser) {
          const projectData = JSON.parse(localStorage.getItem(GUEST_PROJECTS_LOCALSTORAGE_KEY) || "[]");
          const currentProject = projectData.find((p) => p.id === projectId);

          if (currentProject) {
            currentProject.products.push({
              brand,
              name: name.getText(),
              leadTime: leadTime ? leadTime : "N/A",
              notes: "",
              price,
              salePrice,
              productSlug,
              projectId,
              qty: 1,
              thumbnail,
              category: rowData.name,
              project: {
                projectName: currentProject.projectName,
              },
            });

            currentProject.noOfProducts = (currentProject.noOfProducts || 0) + 1;
            localStorage.setItem(GUEST_PROJECTS_LOCALSTORAGE_KEY, JSON.stringify(projectData));

            notificationTitle.setText(currentProject.projectName);
            notificationTrigger.getElement().click();
            cancelProjectButtonModal.getElement().click();

            setTimeout(() => {
              engagementPopupTrigger.getElement().click();
            }, 1000);
          }
        } else {
          addToProjectReq.fetch({
            brand,
            leadTime: leadTime ? leadTime : "N/A",
            name: name.getText(),
            notes: "",
            price: price ? price : 0,
            salePrice: salePrice ? salePrice : 0,
            productSlug,
            projectId,
            qty: 1,
            thumbnail,
            category: rowData.name,
          });
        }
      });

      return rowElement;
    });

    if (isGuestUser) {
      listRoomsGuestReq.onData((guestRoomData) => {
        let roomsData = JSON.parse(localStorage.getItem(GUEST_ROOMS_LOCALSTORAGE_KEY) || "[]");
        if (roomsData && roomsData.length) {
          roomsData = roomsData.map((r) => ({
            id: r.id,
            name: r.name,
            thumbnail: r.thumbnail || ROOM_THUMBNAIL,
          }));
          localStorage.setItem(GUEST_ROOMS_LOCALSTORAGE_KEY, JSON.stringify(roomsData));
          globalGuestRoomData = guestRoomData.listRoomsGuest;
          roomsData = [...guestRoomData.listRoomsGuest, ...roomsData];
          roomsList.setData(roomsData);
        } else {
          globalGuestRoomData = guestRoomData.listRoomsGuest;
          localStorage.setItem(GUEST_ROOMS_LOCALSTORAGE_KEY, JSON.stringify([]));
          roomsList.setData(guestRoomData.listRoomsGuest);
        }
        // let roomsData = JSON.parse(localStorage.getItem(GUEST_ROOMS_LOCALSTORAGE_KEY) || "[]");
        // roomsData = roomsData.map((r) => {
        //   return {
        //     id: r.id,
        //     name: r.name,
        //     thumbnail: r.thumbnail || ROOM_THUMBNAIL,
        //   }
        // });
        // roomsList = [...data.listRoomsGuest, ...roomsData];
      });
      listRoomsGuestReq.fetch();
    } else {
      listRoomsReq.onData((data) => {
        roomsList.setData(
          data.listRooms.map((r) => ({
            id: r.id,
            name: r.name,
            thumbnail: r.thumbnail,
          }))
        );
      });
      listRoomsReq.fetch();
    }
  };
  initRooms();
  const setGuestListData = (data) => {
    const projectsData = data.map((p) => {
      return {
        "project-name": p.projectName,
        "project-image": p.thumbnail ? S3_BASE_URL + p.thumbnail : PLACEHOLDER_IMAGE,
        "no-of-products": p.noOfProducts || 0,
        "project-id": p.id,
      };
    });
    numberOfProjects = projectsData.length;
    updateEmptyState(numberOfProjects);
    if (projectsData.length < 3) {
      if (projectsData.length === 2) {
        projectsData.push({
          "project-name": "",
          "project-image": "",
          "no-of-products": 0,
          "project-id": "0",
        });
      } else if (projectsData.length === 1) {
        projectsData.push({
          "project-name": "",
          "project-image": "",
          "no-of-products": 0,
          "project-id": "0",
        });
        projectsData.push({
          "project-name": "",
          "project-image": "",
          "no-of-products": 0,
          "project-id": "0",
        });
      }
    }
    projectList.setData(projectsData);
  };
  let projectId;
  let numberOfProjects = 0;
  const projectList = new WFDynamicList<
    {
      "project-image": string;
      "project-name": string;
      "project-id": string;
      "no-of-products": number;
    },
    HTMLDivElement,
    HTMLDivElement,
    HTMLDivElement
  >(`[xa-type="project-list"]`, {
    rowSelector: `[xa-type="project-item"]`,
  });

  projectList.rowRenderer(({ rowData, rowElement, index }) => {
    if (numberOfProjects < 3 && index >= numberOfProjects) {
      rowElement.addCssClass("disabled-item");
    }
    const image = rowElement.getChildAsComponent(`[xa-type="project-image"]`);
    image.setAttribute("src", rowData["project-image"]);
    image.setAttribute("srcset", rowData["project-image"]);
    const projectName = rowElement.getChildAsComponent(`[xa-type="project-name"]`);
    const noOfProducts = rowElement.getChildAsComponent(`[xa-type="no-of-products"]`);
    projectName.setText(rowData["project-name"]);
    noOfProducts.setText(`${rowData["no-of-products"]} Saved`);

    rowElement.on("click", () => {
      const notificationLinkHandler = () => {
        navigate(`${PUBLIC_PATHS.projectDetailsPage}?id=${rowData["project-id"]}`);
      };

      if (isGuestUser) {
        const listData = JSON.parse(localStorage.getItem(GUEST_PROJECTS_LOCALSTORAGE_KEY) || "[]");
        listData.forEach((p) => {
          if (!p?.products) {
            p.products = [];
          }
          if (p.id === rowData["project-id"]) {
            projectId = p.id;

            const setRoomClickListner = () => {
              const roomListExt = new WFComponent(`[xa-type="room-list"]`);
              const roomItemsList = roomListExt.getChildAsComponents(`[xa-type="room-item"]`);
              const listners = [];

              const roomClickHandler = (e: any) => {
                const room = e.currentTarget.innerText;
                p.products.push({
                  brand,
                  name,
                  leadTime: leadTime ? leadTime : "N/A",
                  notes: "",
                  price,
                  salePrice,
                  productSlug,
                  projectId,
                  qty: 1,
                  thumbnail,
                  category: room,
                  project: {
                    projectName: p.projectName,
                  },
                });
                p.noOfProducts = p.noOfProducts + 1;

                localStorage.setItem(GUEST_PROJECTS_LOCALSTORAGE_KEY, JSON.stringify(listData));

                notificationTitle.setText(p.projectName);
                notificationLink.on("click", notificationLinkHandler);
                setTimeout(() => {
                  notificationLink.getElement().removeEventListener("click", notificationLinkHandler);
                }, 5000);
                notificationTrigger.getElement().click();
                cancelProjectButtonModal.getElement().click();

                listners.forEach((l) => {
                  if (l && typeof l.off === "function") {
                    l.off("click", roomClickHandler);
                  }
                });

                setTimeout(() => {
                  engagementPopupTrigger.getElement().click();
                }, 1000);
              };

              roomItemsList.forEach((rl) => {
                listners.push(rl);
                rl.on("click", roomClickHandler);
              });
            };

            cancelProjectButtonModal.getElement().click();
            setTimeout(() => {
              roomsListpopupTrigger.getElement().click();
              setRoomClickListner();
            }, 500);
          }
        });
      } else {
        addToProjectReq.onData((data) => {
          if (data.addToProject) {
            notificationTitle.setText(rowData["project-name"]);
            notificationLink.on("click", notificationLinkHandler);
            setTimeout(() => {
              notificationLink.getElement().removeEventListener("click", notificationLinkHandler);
            }, 5000);
            notificationTrigger.getElement().click();
            cancelProjectButtonModal.getElement().click();
          }
        });
        const setRoomClickListner = () => {
          const roomListExt = new WFComponent(`[xa-type="room-list"]`);
          const roomItemsList = roomListExt.getChildAsComponents(`[xa-type="room-item"]`);
          const listners = [];

          const roomClickHandler = (e: any) => {
            if (!rowData["project-id"]) return;

            const room = e.currentTarget.innerText;
            addToProjectReq.fetch({
              brand,
              leadTime: leadTime ? leadTime : "N/A",
              name,
              notes: "",
              price: price ? price : 0,
              salePrice: salePrice ? salePrice : 0,
              productSlug,
              projectId: rowData["project-id"],
              qty: 1,
              thumbnail,
              category: room,
            });

            listners.forEach((l) => {
              if (l && typeof l.off === "function") {
                l.off("click", roomClickHandler);
              }
            });
          };

          roomItemsList.forEach((rl) => {
            listners.push(rl);
            rl.on("click", roomClickHandler);
          });

          roomsListpopupTrigger.getElement().click();
        };
        setRoomClickListner();
      }
    });
    return rowElement;
  });

  listProjectReq.onData((data) => {
    const projectsData = data.listProjects.map((p) => {
      return {
        "project-name": p.projectName,
        "project-image": p.thumbnail ? S3_BASE_URL + p.thumbnail : PLACEHOLDER_IMAGE,
        "no-of-products": p.noOfProducts || 0,
        "project-id": p.id,
      };
    });
    numberOfProjects = projectsData.length;
    updateEmptyState(numberOfProjects);
    if (projectsData.length < 3) {
      if (projectsData.length === 2) {
        projectsData.push({
          "project-name": "",
          "project-image": "",
          "no-of-products": 0,
          "project-id": "0",
        });
      } else if (projectsData.length === 1) {
        projectsData.push({
          "project-name": "",
          "project-image": "",
          "no-of-products": 0,
          "project-id": "0",
        });
        projectsData.push({
          "project-name": "",
          "project-image": "",
          "no-of-products": 0,
          "project-id": "0",
        });
      }
    }
    projectList.setData(projectsData);
  });

  createNewProjectReq.onData((data) => {
    if (data.addNewProject) {
      listProjectReq.fetch();
      const setRoomClickListner = () => {
        const roomListExt = new WFComponent(`[xa-type="room-list"]`);
        const roomItemsList = roomListExt.getChildAsComponents(`[xa-type="room-item"]`);
        const listners = [];
        const roomClickHandler = (e: any) => {
          const room = e.currentTarget.innerText;
          addToProjectReq.fetch({
            brand,
            leadTime: leadTime ? leadTime : "N/A",
            name,
            notes: "",
            price: price ? price : 0,
            salePrice: salePrice ? salePrice : 0,
            productSlug,
            projectId: data.addNewProject.id,
            qty: 1,
            thumbnail,
            category: room,
          });
          listners.forEach((l) => {
            try {
              l.removeEventListener("click", roomClickHandler);
            } catch (e) {
              console.log("Error in room listners");
            }
          });
        };
        roomItemsList.forEach((rl) => {
          listners.push(rl.on("click", roomClickHandler));
        });
      };
      setRoomClickListner();
      // const notificationLinkHandler = () => {
      //   navigate(`${PUBLIC_PATHS.projectDetailsPage}?id=${data.addNewProject.id}`);
      // };
      // notificationTitle.setText(data.addNewProject.projectName);
      // notificationLink.on("click", notificationLinkHandler);
      // setTimeout(() => {
      //   notificationLink.getElement().removeEventListener("click", notificationLinkHandler);
      // }, 5000);
      // notificationTrigger.getElement().click();
      cancelProjectButtonModal.getElement().click();
      setTimeout(() => {
        roomsListpopupTrigger.getElement().click();
      }, 500);
    }
  });

  createNewProjectReq.onError((err) => {
    errorMessageBox.setText("Something went wrong while adding new project!");
  });

  createProjectButtonModal.on("click", () => {
    formSubmitButton.getElement().click();
  });

  addProjectForm.onFormSubmit((data) => {
    const projectNameInput = new WFComponent("#project-name");
    const projectName = data["project-name"].trim();

    if (!projectName || projectName.length < 3) {
      projectNameInput.setStyle({
        borderColor: "var(--transparent) var(--transparent) #ff4848",
      });
      return;
    }

    projectNameInput.setStyle({
      borderColor: "var(--transparent) var(--transparent) var(--primary--shades--p800-dim)",
    });

    if (isGuestUser) {
      const newProjectId = generateRandomId();
      const projectData = JSON.parse(localStorage.getItem(GUEST_PROJECTS_LOCALSTORAGE_KEY) || "[]");

      projectData.push({
        projectName: projectName,
        id: newProjectId,
        noOfProducts: 0,
        products: [],
      });

      localStorage.setItem(GUEST_PROJECTS_LOCALSTORAGE_KEY, JSON.stringify(projectData));
      setGuestListData(projectData);
      projectId = newProjectId;
      cancelProjectButtonModal.getElement().click();

      setTimeout(() => {
        roomsListpopupTrigger.getElement().click();

        const roomListExt = new WFComponent(`[xa-type="room-list"]`);
        const roomItems = roomListExt.getChildAsComponents(`[xa-type="room-item"]`);

        roomItems.forEach((roomItem) => {
          roomItem.on("click", () => {
            const selectedRoom = roomItem.getChildAsComponent(`[xa-type="room-name"]`).getText();
            handleRoomSelection(newProjectId, selectedRoom);
          });
        });
      }, 500);
    } else {
      createNewProjectReq.fetch({
        name: projectName,
      });
    }
  });

  if (isGuestUser) {
    const data = JSON.parse(localStorage.getItem(GUEST_PROJECTS_LOCALSTORAGE_KEY) || "[]");
    setGuestListData(data);
  } else {
    listProjectReq.fetch();
  }

  addToProjectReq.onData((data) => {
    // console.log("🚀 ~ addToProjectReq.onData ~ data:", data);
    cancelProjectButtonModal.getElement().click();
  });

  addToProjectButton.on("click", () => {
    if (isGuestUser) {
    } else {
      // const setRoomClickListner = () => {
      //   const roomListExt = new WFComponent(`[xa-type="room-list"]`);
      //   const roomItemsList = roomListExt.getChildAsComponents(`[xa-type="room-item"]`);
      //   const listners = [];
      //   const roomClickHandler = (e: any) => {
      //     const room = e.target.innerText;
      //     addToProjectReq.fetch({
      //       brand,
      //       leadTime: leadTime ? leadTime : "N/A",
      //       name,
      //       notes: "",
      //       price: price ? price : 0,
      //       salePrice: salePrice ? salePrice : 0,
      //       productSlug,
      //       projectId,
      //       qty: 1,
      //       thumbnail,
      //       category: room
      //     });
      //     listners.forEach((l) => {
      //       l.removeEventListener("click", roomClickHandler);
      //     });
      //   };
      //   roomItemsList.forEach(rl => {
      //     listners.push(
      //       rl.on("click", roomClickHandler)
      //     );
      //   });
      // };
      // setRoomClickListner();
    }
  });
};

const generateRandomId = () => {
  return Math.random().toString(16).slice(2);
};

// Single quote product code
const requestQuoteForm = new WFFormComponent<{
  "First-Name": string;
  "Last-Name": string;
  Email: string;
  Phone: string;
  City: string;
  Country: string;
  "help-text": string;
}>(`[xa-type="quote-form"]`);

const formLoader = new WFComponent(`[xa-type="form-loader"]`);
const closeButton = new WFComponent(`[xa-type="quote-popup-close-btn"]`);
const sendSingleProductQuoteReq = publicQL.mutation(SendSingleProductQuoteDocument);

const getProductInfo = () => {
  const productNameInput = new WFComponent<HTMLInputElement>(`input[name="Product-Name"]`);
  const productBrand = new WFComponent(`[xa-type="product-brand"]`);
  const productImage = new WFComponent(`.product-header_image`);
  return {
    name: productNameInput.getAttribute("value") || productNameInput.getElement().value,
    brand: productBrand.getText(),
    image: productImage.getAttribute("src"),
    qty: 1,
  };
};

requestQuoteForm.onFormSubmit((data) => {
  formLoader.removeCssClass("hide");
  const productInfo = getProductInfo();

  const quoteData = {
    user: {
      firstName: data["First-Name"],
      lastName: data["Last-Name"],
      email: data.Email,
      phoneNumber: data.Phone,
      city: data.City,
      country: data.Country,
      helpText: data["help-text"],
    },
    product: {
      name: productInfo.name,
      image: productInfo.image,
      brand: productInfo.brand,
      qty: productInfo.qty,
    },
  };

  sendSingleProductQuoteReq.fetch({
    quoteData: JSON.stringify(quoteData),
  });
});

sendSingleProductQuoteReq.onData(() => {
  formLoader.addCssClass("hide");
  closeButton.getElement().click();
});

sendSingleProductQuoteReq.onError(() => {
  formLoader.addCssClass("hide");
});
